import { useState, useEffect } from 'react'
import _ from 'lodash'
import isEmail from 'validator/lib/isEmail'
import isUrl from 'validator/lib/isURL'
import isPhone from 'validate-phone-number-node-js'

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

import IconEmail from '@mui/icons-material/EmailOutlined'
import IconWWW from '@mui/icons-material/Public'
import IconPhone from '@mui/icons-material/LocalPhone'
import DeleteIcon from '@mui/icons-material/Delete'
import NotesIcon from '@mui/icons-material/Notes'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'

import CustomTextField from '../common/wizard-custom-textfield'

const BusinessContacts = ({ setPrevButtonState, setNextButtonState, template, setTemplate, objectData, setObjectData, classData, setClassData }) => {

  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("disabled")
  }, [])

  useEffect(() => {
    const state = template.backFields.length > 0 ? "enabled" : "disabled"
    setNextButtonState(state)
  }, [template])

  const deleteContact = key => {
    // Apple
    let t = _.cloneDeep(template)
    t.backFields = t.backFields.filter(c => c.key !== key)

    t.backFields.map((c, i) => {
      c.key = "B" + i
    })

    setTemplate(t)

    // Google
    let c = _.cloneDeep(classData)
    let o = _.cloneDeep(objectData)

    o.linksModuleData.uris = o.linksModuleData.uris.filter(c => c.id !== key)
    o.textModulesData = o.textModulesData.filter(c => c.id !== key)

    let details = c.classTemplateInfo.detailsTemplateOverride.detailsItemInfos
    let newDetails = details.filter(c => c.item.firstValue.fields[0].fieldPath.replace(/.*\['(.*)'\].*/,"$1") !== key)

    newDetails.map((d, i) => {
      let oldId = d.item.firstValue.fields[0].fieldPath.replace(/.*\['(.*)'\].*/,"$1")
      let newId = "B"+i
      d.item.firstValue.fields[0].fieldPath = d.item.firstValue.fields[0].fieldPath.replace(oldId,newId)

      let linkItem = o.linksModuleData.uris.findIndex(i => i.id === oldId)
      let textItem = o.textModulesData.findIndex(i => i.id === oldId)

      if (linkItem !== -1) o.linksModuleData.uris[linkItem].id = newId
      if (textItem !== -1) o.textModulesData[textItem].id = newId
    })

    c.classTemplateInfo.detailsTemplateOverride.detailsItemInfos = newDetails

    setClassData(c)
    setObjectData(o)
  }

  const addContact = contact => {

    contact.key = "B" + template.backFields.length

    let t = _.cloneDeep(template)
    t.backFields.push(contact)
    setTemplate(t)

    let c = _.cloneDeep(classData)

    let newId = "B" + c.classTemplateInfo.detailsTemplateOverride.detailsItemInfos.length

    let fieldPath = (contact.type === "text") ? `object.textModulesData['${newId}']` : `object.linksModuleData.uris['${newId}']`

    let classItem = {
      item : {
        firstValue : {
          fields : [{
            fieldPath : fieldPath
          }]
        }
      }
    }
    
    c.classTemplateInfo.detailsTemplateOverride.detailsItemInfos.push(classItem)

    setClassData(c)

    let o = _.cloneDeep(objectData)

    if (contact.type === "text") {
      o.textModulesData.push({
        id : newId,
        header : contact.label,
        body : contact.value
      })
    } else {
      o.linksModuleData.uris.push({
        id : newId,
        description : contact.label,
        type : contact.type,
        uri : contact.value
      })
    }

    setObjectData(o)
  }

  const moveContact = (from, to) => {

    // Apple
    let t = _.cloneDeep(template)
    let ac = t.backFields.splice(from, 1)[0]
    t.backFields.splice(to, 0, ac)
    t.backFields.map((a, i) => {
      a.key = "B" + i
    })
    setTemplate(t)

    // Google Class
    let c = _.cloneDeep(classData)
    let details = c.classTemplateInfo.detailsTemplateOverride.detailsItemInfos

    let gc = details.splice(from, 1)[0]
    details.splice(to, 0, gc)
    details.map((d, i) => {
      d.key = "B" + i
    })

    setClassData(c)
  }


  return (
    <div className="pb-10">
      <Typography variant="h3" sx={{ p: 2 }}>Contact Details</Typography>

      <div className="flex flex-col gap-3 w-full mb-10">
        {template.backFields.map((c, i) => (
          <div key={c.key} className=" flex flex-row w-full">
            <div className="w-1/12">{typeIcon(c.type)}</div>
            <div className="w-2/12">{c.label}</div>
            <div className="w-7/12">{c.value}</div>
            <div className="w-2/12 flex-nowrap text-nowrap">
              <IconButton color="primary" onClick={() => moveContact(i, i-1)} disabled={i === 0}><ArrowUpwardIcon /></IconButton>
              <IconButton color="primary" onClick={() => moveContact(i, i+1)} disabled={i === (template.backFields.length - 1)}><ArrowDownwardIcon /></IconButton>
              <IconButton color="error" onClick={() => deleteContact(c.key)}><DeleteIcon /></IconButton>
            </div>
          </div>
        ))}
      </div>

      <div>
        <AddContactForm addContact={addContact} />
      </div>
    </div>
  )
}

export default BusinessContacts

const typeIcon = type => {
  switch (type) {
    case 'text': return <NotesIcon />
    case 'email': return <IconEmail />
    case 'phone': return <IconPhone />
    case 'www': return <IconWWW />
  }
}

const AddContactForm = ({ addContact }) => {
  const [type, setType] = useState("www")
  const [protocol, setProtocol] = useState("https://")
  const [label, setLabel] = useState("")
  const [value, setValue] = useState("")
  const [valueValid, setValueValid] = useState(false)

  const handleAddContact = () => {

    const fullValue = type === "www" ? protocol + value : value

    let contact = { type, label, value: fullValue }
    addContact(contact)

    setLabel("")
    setValue("")
    setValueValid(false)
    setType("www")
    setProtocol("https://")
  }


  const setNewValue = newValue => {
    setValue(newValue)

    if (type === "www") {
      setValueValid(isUrl(newValue, { require_valid_protocol: true, protocols: [] }))
    } else if (type === "email") {
      setValueValid(isEmail(newValue))
    } else if (type === "phone") {
      setValueValid(isPhone.validate(newValue))
    } else {
      setValueValid(newValue.length > 1)
    }
  }


  return (
    <div className="flex flex-col gap-5 w-full mb-10">

      <Typography variant="h4" sx={{ p: 2 }}>Add Contact</Typography>

      <div className="flex flex-row gap-5 w-full">
        <Typography variant="h6" sx={{ p: 2 }}>Contact type:</Typography>

        <Select
          value={type}
          onChange={e => setType(e.target.value)}
          className="w-1/12"
          sx={{ width: 120, height: 56 }}>
          <MenuItem value="email">Email</MenuItem>
          <MenuItem value="phone">Phone</MenuItem>
          <MenuItem value="www">Website</MenuItem>
          <MenuItem value="text">Note</MenuItem>
        </Select>
      </div>

      <CustomTextField label="Label" valid={label.length > 1} value={label} onChange={setLabel} helperText="Apple only, except for notes fields"/>

      {type === "www" &&
        <div className="flex flex-row gap-5 w-full">
          <Select
            value={protocol}
            onChange={e => setProtocol(e.target.value)}
            className="w-1/12"
            sx={{ width: 100, height: 56 }}>
            <MenuItem value="https://">https://</MenuItem>
            <MenuItem value="http://">http://</MenuItem>
          </Select>

          <CustomTextField label="Website URL" value={value} valid={valueValid} onChange={setNewValue} style={{ width: 320 }} />

        </div>}

      {type === "email" &&
        <CustomTextField label="Email Address" valid={valueValid} value={value} onChange={setNewValue} />
      }

      {type === "phone" &&
        <CustomTextField label="Phone Number" valid={valueValid} value={value} onChange={setNewValue} />
      }

      {type === "text" &&
        <CustomTextField label="Notes" valid={value.length > 1} value={value} onChange={setNewValue} multiline />
      }

      <Button variant="outlined" onClick={handleAddContact} disabled={label.length < 2 || !valueValid}><NotesIcon /> Add contact</Button>
    </div>
  )
}

